/** Ordered onboarding wizard: URL segment per step (trailing-slash routes). */
export const ONBOARDING_STEP_SLUGS = ["brand", "reply-style", "gmail"];

export const ONBOARDING_FIRST_PATH = "/onboarding/brand/";

/** Mailbox OAuth must return here so the user stays on Connect Gmail after Google redirect. */
export const ONBOARDING_MAILBOX_RETURN_PATH = "/onboarding/gmail/";

export function onboardingPathForStep(stepNumber) {
  const slug = ONBOARDING_STEP_SLUGS[stepNumber - 1];
  if (!slug) return ONBOARDING_FIRST_PATH;
  return `/onboarding/${slug}/`;
}

export function onboardingStepFromSlug(slug) {
  const idx = ONBOARDING_STEP_SLUGS.indexOf(slug);
  return idx >= 0 ? idx + 1 : null;
}
